import { default_pods_input_state_smart_get, virtel_schema_smart_get } from "./ter-virtel-definition-lib";
import { _get_fixed_fields } from "./ter-virtel-utils";
import { _getParamsFromLib } from "./ter-params-utils";
import { protobomp_manipulator, protobomp_utils_get_children_of_pbnode, protobomp_utils_get_superdata } from "../utils/frfr-protobomp-utils";
import { virbomCounter } from "../utils/frfr-virbom-counter-utils";
import tclocal from "./ter-consts-local-lib";
import { _virbom_manipulator } from "../utils/frfr-virbom-manipulator-utils";
import { _enrich_virtel_from_unbundled_subDraftel_arr_with_fresh_subkey } from "./ter-virbom-datarender";
import { SINGLE_PIECE_PER_NEXT_OPERATION_UNIT } from "./virtel-consts";
import { terUtilsUnitsMilimetriToMetri } from "./ter-utils";
// import { _pbnode_to_virbom_PRIMITIVE_ZZKITC_WBP, _pbnode_to_virbom_ASSEMBLY_ZZKITC_ASY } from "../utils/zz/zz-derivat-lib-zzkitc";
import { terProtbompUtils_extract_terkk_protobompclass_from_protobomp } from "./ter-protobomp-utils";
import { _derivat_terkk_prb_pbnode_dirty_enrich } from "./ter-derivat-lib-terkk-prigusivacbuke";
import { _derivat_terkk_klizac_pbnode_dirty_enrich } from "./ter-derivat-lib-terkk-klizac";
import { _derivat_terkk_pkz_pbnode_dirty_enrich } from "./ter-derivat-lib-terkk-protivkisnazaluzina";
import { _derivat_terkk_parniovlazivac_pbnode_dirty_enrich } from "./ter-derivat-lib-terkk-parniovlazivac";
import { _derivat_terkk_kucisteelektrogrejaca_pbnode_dirty_enrich } from "./ter-derivat-lib-terkk-kucisteelektrogrejaca";
import { _derivat_terkk_nrr_pbnode_dirty_enrich } from "./ter-derivat-lib-terkk-nrr";
import { _derivat_terkk_npr_pbnode_dirty_enrich } from "./ter-derivat-lib-terkk-npr";
import { _derivat_terkk_ppvnosacv_pbnode_dirty_enrich } from "./ter-derivat-lib-terkk-ppv";
import { _derivat_terkk_ramfilteranauklizavanje_dirty_enrich } from "./ter-derivat-lib-terkk-ramfilteranauklizavanje";
import { _derivat_terkk_kadica_v2_pbnode_dirty_enrich } from "./ter-derivat-lib-terkk-kadica";
import { _derivat_terkk_usmerivacvazduha_pbnode_dirty_enrich } from "./ter-derivat-lib-terkk-usmerivacvazduha";
import { _derivat_terkk_paletapakovanja_pbnode_dirty_enrich } from "./ter-derivat-lib-terkk-paletapakovanja";
import { _derivat_terkk_rmt_pbnode_dirty_enrich } from "./ter-derivat-lib-terkk-rammraztermostata";
import { js_utils } from "../utils/frfr-js-utils";
import { _derivat_terkk_ppd_pbnode_dirty_enrich } from "./ter-derivat-lib-terkk-ppd";


// TER DRAFTEL CODECS LIB

/*
// PPGRUPA PRB
U IZRADI
ovo je zapravo GRUPA OD 2 POLUPROIZVODA koji se zajednicki unose i izracunavaju ali mogu i posebno

TODO:
- 

*/


export const draftel_codecs_pack_terkk$_special_protobomp = {};


// ---------- CODEC SCHEMA METHODS ----------


/////////


// ---------- CODEC ENCODING  - DRAFTEL TO VIRBOM DIRECTION ----------


// ----- * PROTOBOMP MULTIADAPTER ----------


// TODO
const _protobomp_multiadapter = () => {
  const multiadapter_lib = {};
  const TEMP_TITLE = "TEMP_TITLE";
  const PBNODE_HANDLECHNAGE_MODULE = "pbnode_handleChange_module"; // state handlechange
  //
  // ---- LIB
  //
  multiadapter_lib["terkk$klizac"] = {
    [TEMP_TITLE]: "terkk$klizac",
    [PBNODE_HANDLECHNAGE_MODULE]: (pbnode_state_ref, protobomp_superdata) => {
      return _derivat_terkk_klizac_pbnode_dirty_enrich(pbnode_state_ref, protobomp_superdata);
    },

  };
  //
  //
  // -----METHODS
  const _adapter_methods = {};
  //
  _adapter_methods.pbnode_handleChange_module = (protobomp) => {
    let virbom = null;
    const terkk_protobompclass = terProtbompUtils_extract_terkk_protobompclass_from_protobomp(protobomp);
    if (multiadapter_lib[terkk_protobompclass] && typeof multiadapter_lib[terkk_protobompclass][PBNODE_HANDLECHNAGE_MODULE] === 'function') {
      virbom = multiadapter_lib[terkk_protobompclass][PBNODE_HANDLECHNAGE_MODULE](protobomp);
    }
    return virbom;
  };
  //
  return _adapter_methods;
  // return false;
};


//
export const _pbnode_dirty_enrich_adapter = (pbnode_state_ref, protobomp_superdata, terkk_protobompclass) => {
  // const terkk_protobompclass = terProtbompUtils_extract_terkk_protobompclass_from_protobomp(protobomp);
  //
  if (terkk_protobompclass === "terkk$kadica_v2") {
    // TODO kadicu pretvoriti u kadica v2
    // TODO state mutator sa payloadom za materijale
    return _derivat_terkk_kadica_v2_pbnode_dirty_enrich(pbnode_state_ref, protobomp_superdata); // UZOR ZA NOVE
  }
  if (terkk_protobompclass === "terkk$klizac") {
    return _derivat_terkk_klizac_pbnode_dirty_enrich(pbnode_state_ref, protobomp_superdata);
  }
  if (terkk_protobompclass === "terkk$prigusivacbuke") {
    return _derivat_terkk_prb_pbnode_dirty_enrich(pbnode_state_ref, protobomp_superdata);
  }
  if (terkk_protobompclass === "terkk$ramfuk") { // ramfilteranauklizavanje IMA 2 bundle i obican TODO
    // TODO state mutator sa payloadom za materijale
    return _derivat_terkk_ramfilteranauklizavanje_dirty_enrich(pbnode_state_ref, protobomp_superdata); // UZOR ZA NOVE
  }
  if (terkk_protobompclass === "terkk$ppvnosacv") {
    // TODO state mutator sa payloadom za materijale
    return _derivat_terkk_ppvnosacv_pbnode_dirty_enrich(pbnode_state_ref, protobomp_superdata); // UZOR ZA NOVE
    //
  }
  if (terkk_protobompclass === "terkk$rmt") {
    // TODO
    return _derivat_terkk_rmt_pbnode_dirty_enrich(pbnode_state_ref, protobomp_superdata); // UZOR ZA NOVE
  }
  if (terkk_protobompclass === "terkk$npr") {
    return _derivat_terkk_npr_pbnode_dirty_enrich(pbnode_state_ref, protobomp_superdata); // UZOR ZA NOVE
  }
  if (terkk_protobompclass === "terkk$nrr") {
    return _derivat_terkk_nrr_pbnode_dirty_enrich(pbnode_state_ref, protobomp_superdata); // UZOR ZA NOVE
  }
  if (terkk_protobompclass === "terkk$pkz") {
    return _derivat_terkk_pkz_pbnode_dirty_enrich(pbnode_state_ref, protobomp_superdata); // UZOR ZA NOVE
  }
  if (terkk_protobompclass === "terkk$kucisteelektrogrejaca") {
    return _derivat_terkk_kucisteelektrogrejaca_pbnode_dirty_enrich(pbnode_state_ref, protobomp_superdata); // UZOR ZA NOVE
  }
  if (terkk_protobompclass === "terkk$ppd") {
    return _derivat_terkk_ppd_pbnode_dirty_enrich(pbnode_state_ref, protobomp_superdata); // UZOR ZA NOVE
  }
  if (terkk_protobompclass === "terkk$pov") {
    return _derivat_terkk_parniovlazivac_pbnode_dirty_enrich(pbnode_state_ref, protobomp_superdata); // UZOR ZA NOVE
  }
  if (terkk_protobompclass === "terkk$usmerivacvazduha") {
    return _derivat_terkk_usmerivacvazduha_pbnode_dirty_enrich(pbnode_state_ref, protobomp_superdata); // UZOR ZA NOVE
  }
  if (terkk_protobompclass === "terkk$paletapakovanja") {
    return _derivat_terkk_paletapakovanja_pbnode_dirty_enrich(pbnode_state_ref, protobomp_superdata); // UZOR ZA NOVE
  }
  // ...TODO ima jos nekoliko
  // else
  return pbnode_state_ref; // UNCHANGED
};



// ----- * PROTOBOMP TO VIRBOM ----------


//
const _dirty_enrich_virtel_with_dynamic_virtelclass = (virtel, pbnode, op_no) => {
  // based on pbnode
  const p = pbnode.state;
  const family = p.pbnode_family;
  // console.log('virtelclass', virtel.virtelclass);
  // console.log('virtelclass', virtel.virtelclass, 'family', family, 'virtel', virtel);
  if (js_utils.is_string_not_empty(family)) {
    //
    /*
    if (typeof virtel.operacija === 'string' && typeof virtel.rc === 'string') {
      virtel.virtelclass = family + '/' + virtel.operacija + '/' + virtel.rc; // DIRTY
      // console.log('+', virtel.virtelclass);
    }
    */
    //
    virtel.virtelclass = family + '/op' + op_no; // DIRTY
    // console.log('+', virtel.virtelclass);
  }
  //
  if (typeof virtel.virtelclass === 'string') {
    // parametri na kraju imaju prioritet
    const params = _getParamsFromLib(virtel.virtelclass);
    for (const [key, value] of Object.entries(params)) {
      // console.log(`${key}: ${value}`);
      virtel[key] = value;
    }
  }
  // clear junk
  delete virtel.operacija1;
  delete virtel.operacija2;
  delete virtel.operacija3;
  delete virtel.operacija4;
  delete virtel.operacija5; // TODO
  delete virtel.rc1;
  delete virtel.rc2;
  delete virtel.rc3;
  delete virtel.rc4;
  delete virtel.rc5; // TODO
  //
  return virtel; // SAME REF
};


//
// TODO da l ida se koriti = virtel.dimenzija1 ili p.dimenzija1
const _dirty_enrich_virtel_from_pbnode = (virtel, pbnode, protobomp, op_no) => {
  const p = pbnode.state;
  const family = p.pbnode_family;
  const protobomp_superdata = protobomp_utils_get_superdata(protobomp);
  delete virtel.tempkey;
  //
  //
  if (p.tip) {
    virtel.tip = p.tip;
  }
  //
  // * kadica_v2
  if (true) {
    if (family === 'terkk$kadica_v2/SKLOP_KADICA') {
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$kadica/SKLOP_KADICA";
      virtel.duzina = p.duzina;
      virtel.sirina = p.sirina;
      virtel.odvodkondenzata = p.odvodkondenzata;
      virtel.ter_visedelni_koliko_delova = p.ter_visedelni_koliko_delova;
    }
    //
    if (family === 'terkk$kadica_v2/LIM' || family === 'terkk$kadica_v2/LIM_1_2' || family === 'terkk$kadica_v2/LIM_2_2') {
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$kadica/LIM";
      virtel.duzina = p.dimenzija2;
      virtel.sirina = p.dimenzija1;
      if (family === 'terkk$kadica_v2/LIM_1_2') {
        // TODO za P1
      }
    }
  }
  //
  // * klizac
  if (true) {
    if (family === 'terkk$klizac/SKLOP_KLIZAC' || family === 'terkk$klizac/SKLOP_KLIZAC_A' || family === 'terkk$klizac/SKLOP_KLIZAC_B' || family === 'terkk$klizac/SKLOP_KLIZAC_C') {
      virtel.virtelschemakey = "terkk$temp"; // TODO
      // virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$klizac/SKLOP_KLIZAC";
      virtel.tergrupa = 'KLIZAC';
      /*
      Grupa da se zove KLIZAC
      od parametara
      duzina,
      visina klizaca (20 ili 35),
      vrsta lima pocinkovani ili jos bolje porhrom ili da se napise za koji ti komore je
      ***izuzetak je kod bazenske komore gde je sve pocinkovano a maska je prohromska...
      (plastificar nili ne)
      */
      virtel.duzina = p.klizac_duzina;
      virtel.klizac_visina = p.klizac_visina;
      virtel.visina = p.klizac_visina;
      virtel.klizac_tip = p.klizac_tip;
      virtel.klizac_tip_kadice = p.klizac_tip_kadice;
      virtel.klizac_strana_maske = p.klizac_strana_maske;
      virtel.tipkomore = protobomp_superdata.tipkomore;
      virtel.tip = p.tip;
    }
    if (family === 'terkk$klizac/LIM_OMEGA_A' || family === 'terkk$klizac/LIM_OMEGA_B') {
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$klizac/LIM_OMEGA";
      virtel.tergrupa = 'LIM';
      /*
      LIM OMEGA parametri (moraju da bi se razlikovao ident)
      duzina,
      visina, // MOZDA sirina
      tip (tip klizaca) A ili B
      */
      virtel.duzina = p.dimenzija1;
      virtel.visina = p.dimenzija2;
    }
    if (family === 'terkk$klizac/PROFIL_KVAD_C') {
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$grupa_profil/grupa_profil";
      virtel.tergrupa = 'PROFIL';
    }
    if (family === 'terkk$klizac/LIM_L_A' || family === 'terkk$klizac/LIM_L_B' || family === 'terkk$klizac/LIM_L_C') {
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$klizac/LIM_L";
      virtel.tergrupa = 'LIM';
      virtel.duzina = p.dimenzija1;
      virtel.visina = p.dimenzija2;
      // - L profil ima parametre: duzina samo jer je visina svi isti...
    }
    if (
      family === 'terkk$klizac/MASKA_B_LEVA' || family === 'terkk$klizac/MASKA_B_DESNA' || family === 'terkk$klizac/MASKA_B_PLITKA_LEVA' || family === 'terkk$klizac/MASKA_B_PLITKA_DESNA'
      ||
      family === 'terkk$klizac/MASKA_C' || family === 'terkk$klizac/MASKA_C_1_2' || family === 'terkk$klizac/MASKA_C_2_2'
      ||
      family === 'terkk$klizac/MASKA_C_PLITKA' || family === 'terkk$klizac/MASKA_C_PLITKA_1_2' || family === 'terkk$klizac/MASKA_C_PLITKA_2_2'
    ) {
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$klizac/MASKA";
      virtel.tergrupa = 'LIM';
      virtel.duzina = p.dimenzija1;
      virtel.visina = p.dimenzija2;
      /*
      - MASKA parametri duzina, visina klizaca (20 ili 35), tip kadice standardna ili plitka tip klizaca (B ili C), da li je maska dvodelna ili jednodelna odnosno nekakav broj dela da bude 1 ako je prvo deo a 2 ako je drugi deo a nista null ako je jednodelna BROJ DELA U SLUCAJU VISEDELNE
      */
    }
    if (family === 'terkk$klizac/LIM_PLOCICA') {
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$klizac/PLOCICA";
      virtel.tergrupa = 'LIM';
      virtel.duzina = p.dimenzija1;
      virtel.visina = p.dimenzija2;
      /*
      PLOCICA je uvek ista, 88x33 i uvek od istog materijala od parametara duzina sirina samo to. i materijal polje koje je uvek onaj isti...
      */
    }
    //
    //
  }
  //
  // * kelg
  if (true) {
    if (family === 'terkk$kelg/SKLOP_KELG') { // 1.
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$kelg/SKLOP_KELG";
      virtel.distinction_key = p.distinction_key;
      // virtel.tergrupa = 'NOVO';
      // Za ASSEMBLY_TER_SKLOP se mora eksplicitno navesti svako polje koje treba da ide u virtel
      virtel.tip = p.tip;
      virtel.duzina = p.duzina;
      virtel.visina = p.visina;
      virtel.sirina = p.sirina;
      virtel.kelg_kolikoredova = p.kelg_kolikoredova; // TODO ???
      virtel.kelg_kolikogrejacapovisini = p.kelg_kolikogrejacapovisini;
      virtel.kelg_rak_termostat = p.kelg_rak_termostat;
    }
    if (family === 'terkk$kelg/P1' || family === 'terkk$kelg/P2') { //
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$kelg/P12";
      virtel.tip = p.tip;
      //
      virtel.visina = p.dimenzija2;
      virtel.sirina = p.dimenzija1;
    }
    if (family === 'terkk$kelg/P3' || family === 'terkk$kelg/P4') { //
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$kelg/P34";
      virtel.tip = p.tip;
      //
      virtel.duzina = p.dimenzija2;
      virtel.sirina = p.dimenzija1;
    }
    if (family === 'terkk$kelg/P5') { //
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$kelg/P5";
      virtel.tip = p.tip;
      //
      virtel.duzina = p.dimenzija2;
      virtel.visina = p.visina;
      virtel.sirina = p.kelg_sirinakucista;
    }

  }
  //
  // * paletapakovanja ???
  if (true) {
    if (family === 'terkk$paleta/SKLOP_PALETA') { // 1.
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$paleta/SKLOP_PALETA";
      // virtel.tergrupa = 'NOVO';
      // Za ASSEMBLY_TER_SKLOP se mora eksplicitno navesti svako polje koje treba da ide u virtel

    }
    if (family === 'terkk$paleta/P1' || family === 'terkk$paleta/P2' || family === 'terkk$paleta/P3' || family === 'terkk$paleta/P4' || family === 'terkk$paleta/P5') { //
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$paleta/P";

    }

  }
  //
  // * parniovlazivac POV ???
  if (true) {
    /*
    if (family === 'terkk$pov/SKLOP_POV') { // 1.
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$pov/SKLOP_POV";
      // virtel.tergrupa = 'NOVO';
      // Za ASSEMBLY_TER_SKLOP se mora eksplicitno navesti svako polje koje treba da ide u virtel

    }
    */
    if (family === 'terkk$pov/NOSAC_DONJI' || family === 'terkk$pov/NOSAC_GORNJI') { //
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$pov/NOSAC";

    }

  }
  //
  // * ppd
  if (true) {
    if (family === 'terkk$ppd/SKLOP_PPD') { // 1.
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$ppd/SKLOP_PPD";
      virtel.distinction_key = p.distinction_key;
      // virtel.tergrupa = 'NOVO';
      // Za ASSEMBLY_TER_SKLOP se mora eksplicitno navesti svako polje koje treba da ide u virtel
      virtel.tip = p.tip;
      virtel.ppd_b = p.ppd_b;
      virtel.ppd_h = p.ppd_h;
      virtel.ppd_unutrasnjasirinadempera_a = p.ppd_unutrasnjasirinadempera_a;
      virtel.ppd_unutrasnjavisinadempera_c = p.ppd_unutrasnjavisinadempera_c;
      virtel.ppd_g = p.ppd_g;
      virtel.ppd_i = p.ppd_i;
      virtel.ppd_f = p.ppd_f;
    }
    if (family === 'terkk$ppd/P1' || family === 'terkk$ppd/P2' || family === 'terkk$ppd/P3' || family === 'terkk$ppd/P4') { //
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      // virtel.multitranslator_lang = "terkk$ppd/P";
      // virtel.distinction_key = p.distinction_key;
      // virtel.tip = p.tip;
      virtel.ppd_h = p.ppd_h;
      if (family === 'terkk$ppd/P1') {
        virtel.multitranslator_lang = "terkk$ppd/P1";
      }
      if (family === 'terkk$ppd/P2') {
        virtel.multitranslator_lang = "terkk$ppd/P2";
      }
      if (family === 'terkk$ppd/P3') {
        virtel.multitranslator_lang = "terkk$ppd/P3";
      }
      if (family === 'terkk$ppd/P4') {
        virtel.multitranslator_lang = "terkk$ppd/P4";
      }
    }

  }
  //
  // * prb
  if (true) {
    if (family === 'terkk$prbkulisa/SKLOP_KULISA') {
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$prb/SKLOP_KULISA";
      // virtel.tergrupa = 'NOVO';
      virtel.duzina = p.prb_duzinakulisa;
      virtel.visina = p.prb_visinakulisa;
      virtel.sirina = p.prb_sirinakulisa;
      /*
      */
    }
    if (family === 'terkk$prbnosac/SKLOP_NOSAC') {
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$prb/SKLOP_NOSAC";
      // virtel.tergrupa = 'NOVO';
      virtel.duzina = p.prbnosac_omega_duzina;
      virtel.visina = p.visina; // TODO ???
      virtel.sirina = p.prb_sirinakulisa;
      virtel.prb_rastojanjeizmedjukulisa = p.prb_rastojanjeizmedjukulisa;
      /*
      */
    }
    if (family === 'terkk$prbkulisa/ELEMENT_KULISE_H') {
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$prb/ELEMENT_KULISE";
      virtel.duzina = p.dimenzija1;
      virtel.sirina = p.dimenzija2;
    }
    if (family === 'terkk$prbkulisa/ELEMENT_KULISE_V') {
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$prb/ELEMENT_KULISE";
      virtel.duzina = p.dimenzija1;
      virtel.sirina = p.dimenzija2;
    }
    if (family === 'terkk$prbkulisa/U_PROFIL_H') {
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$prb/U_PROFIL";
      virtel.duzina = p.dimenzija1;
      virtel.sirina = p.dimenzija2;
    }
    if (family === 'terkk$prbkulisa/U_PROFIL_VA') {
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$prb/U_PROFIL";
      virtel.duzina = p.dimenzija1;
      virtel.sirina = p.dimenzija2;

    }
    if (family === 'terkk$prbkulisa/U_PROFIL_VB') {
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$prb/U_PROFIL";
      virtel.duzina = p.dimenzija1;
      virtel.sirina = p.dimenzija2;
    }
    if (family === 'terkk$prbkulisa/VUNA_A' || family === 'terkk$prbkulisa/VUNA_B' || family === 'terkk$prbkulisa/VUNA_C' || family === 'terkk$prbkulisa/VUNA_D') {
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$prb/KAMENA_VUNA";
      virtel.duzina = p.duzina;
      virtel.visina = p.visina;
      virtel.debljina = p.debljina;
      virtel.sirina = p.debljina;
    }
    if (family === 'terkk$prbnosac/LIM_OMEGA' || family === 'terkk$prbnosac/LIM_OMEGA_1_2' || family === 'terkk$prbnosac/LIM_OMEGA_2_2') {
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$prb/LIM_OMEGA";
      virtel.duzina = p.dimenzija1;
      virtel.visina = p.dimenzija2; // TODO ???
      virtel.sirina = p.prb_sirinakulisa; // TODO
      virtel.prb_rastojanjeizmedjukulisa = p.prb_rastojanjeizmedjukulisa;

    }
    if (family === 'terkk$prbnosac/SET_STEZACA') {
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$prb/SET_STEZACA";
      virtel.sirina = p.prb_sirinakulisa;
      virtel.prbnosac_brojkomadausetustezaca = p.prbnosac_brojkomadausetustezaca;

    }

  }
  //
  // * pkz
  if (true) {
    if (family === 'terkk$pkz/SKLOP_PKZ') { // 1.
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$pkz/SKLOP_PKZ";
      virtel.distinction_key = p.distinction_key;
      // virtel.tergrupa = 'NOVO';
      // Za ASSEMBLY_TER_SKLOP se mora eksplicitno navesti svako polje koje treba da ide u virtel
      virtel.tip = p.tip;
      virtel.pkz_sirinasvetlogotvora = p.pkz_sirinasvetlogotvora;
      virtel.pkz_visinasvetlogotvora = p.pkz_visinasvetlogotvora;
      virtel.pkz_brojdelova = p.pkz_brojdelova;
      virtel.pkz_brojredova = p.pkz_brojredova;
    }
    if (family === 'terkk$pkz/P1' || family === 'terkk$pkz/P2' || family === 'terkk$pkz/P3' || family === 'terkk$pkz/P4' || family === 'terkk$pkz/P5') { //
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$pkz/P1234";
      virtel.tip = p.tip;
      virtel.pkz_sirinasvetlogotvora = p.pkz_sirinasvetlogotvora;
      virtel.pkz_visinasvetlogotvora = p.pkz_visinasvetlogotvora;
      virtel.duzina = p.dimenzija1;
      virtel.sirina = p.dimenzija2;
      if (family === 'terkk$pkz/P5') {
        virtel.multitranslator_lang = "terkk$pkz/P5";
        virtel.pkz_brojdelova = p.pkz_brojdelova;
      }
    }

  }
  //
  // * RFI ramfiltera ???
  if (true) {
    // NJ: Ovde nemamo sklop za elemente. Svaki element ide zasebno kao i materijal.
    /*
    if (family === 'terkk$rfi/SKLOP_RFI') { // 1.
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$rfi/SKLOP_RFI";
      virtel.distinction_key = p.distinction_key;
      // virtel.tergrupa = 'NOVO';
      // Za ASSEMBLY_TER_SKLOP se mora eksplicitno navesti svako polje koje treba da ide u virtel
    }
    */
    if (family === 'terkk$rfi/NOSAC_SPOLJ' || family === 'terkk$rfi/NOSAC_UNUTR' || family === 'terkk$rfi/UKRUCENJE_SPOLJ' || family === 'terkk$rfi/UKRUCENJE_UNUTR' || family === 'terkk$rfi/SET_STEZACA') { //
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      // virtel.multitranslator_lang = "terkk$rfi/P";
      //
      virtel.duzina = p.dimenzija1;
      virtel.sirina = p.dimenzija2;
      //
      if (family === 'terkk$rfi/NOSAC_SPOLJ' || family === 'terkk$rfi/NOSAC_UNUTR') { //
        virtel.multitranslator_lang = "terkk$rfi/NOSAC";
        //
        virtel.visina = p.visina;
      }
      if (family === 'terkk$rfi/UKRUCENJE_SPOLJ' || family === 'terkk$rfi/UKRUCENJE_UNUTR') { //
        virtel.multitranslator_lang = "terkk$rfi/UKRUCENJE";
      }
      if (family === 'terkk$rfi/SET_STEZACA') { //
        virtel.multitranslator_lang = "terkk$rfi/SET_STEZACA";
      }
    }

  }
  //
  // * ramfuk
  if (true) {
    if (family === 'terkk$ramfuk/SKLOP_RAMFUK') { // 1-
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$ramfuk/SKLOP_RAMFUK";
      // virtel.tergrupa = 'NOVO';
      // Za ASSEMBLY_TER_SKLOP se mora eksplicitno navesti svako polje koje treba da ide u virtel
      virtel.tip = p.tip;
      virtel.sirina = p.ramfuk_sirinab;
      virtel.visina = p.ramfuk_visinah;
      virtel.tervrstaprofila_50_ili_70 = p.tervrstaprofila_50_ili_70;
      virtel.ramfuk_tipfiltera = p.ramfuk_tipfiltera;
    }
    if (family === 'terkk$ramfuk/NOSAC_V_LEVI') { // 1-
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$ramfuk/NOSAC_V";
      // virtel.tergrupa = 'NOVO';
      virtel.tip = p.tip;
      virtel.visina = p.razvijenamera1;
      // virtel.tervrstaprofila_50_ili_70 = p.tervrstaprofila_50_ili_70;
    }
    if (family === 'terkk$ramfuk/NOSAC_V_DESNI') { // 1-
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$ramfuk/NOSAC_V";
      // virtel.tergrupa = 'NOVO';
      virtel.tip = p.tip;
      virtel.visina = p.razvijenamera1;
      // virtel.tervrstaprofila_50_ili_70 = p.tervrstaprofila_50_ili_70;
    }
    if (family === 'terkk$ramfuk/NOSAC_OMEGA' || family === 'terkk$ramfuk/NOSAC_OMEGA_1_2' || family === 'terkk$ramfuk/NOSAC_OMEGA_2_2') { // 1-
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$ramfuk/NOSAC_OMEGA";
      // virtel.tergrupa = 'NOVO';
      virtel.tip = p.tip;
      virtel.sirina = p.razvijenamera1;
      // virtel.tervrstaprofila_50_ili_70 = p.tervrstaprofila_50_ili_70;
    }

    if (family === 'terkk$ramfuk/KLIZAC_GORNJI' || family === 'terkk$ramfuk/KLIZAC_GORNJI_1_2' || family === 'terkk$ramfuk/KLIZAC_GORNJI_2_2') { // 1-
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$ramfuk/KLIZAC_GORNJI_DONJI";
      // virtel.tergrupa = 'NOVO';
      virtel.tip = p.tip;
      virtel.sirina = p.razvijenamera1;
      virtel.tervrstaprofila_50_ili_70 = p.tervrstaprofila_50_ili_70;
      virtel.ramfuk_tipfiltera = p.ramfuk_tipfiltera;
    }
    if (family === 'terkk$ramfuk/KLIZAC_DONJI' || family === 'terkk$ramfuk/KLIZAC_DONJI_1_2' || family === 'terkk$ramfuk/KLIZAC_DONJI_2_2') { // 1-
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$ramfuk/KLIZAC_GORNJI_DONJI";
      // virtel.tergrupa = 'NOVO';
      virtel.tip = p.tip;
      virtel.sirina = p.razvijenamera1;
      // virtel.tervrstaprofila_50_ili_70 = p.tervrstaprofila_50_ili_70;
      // virtel.ramfuk_tipfiltera = p.ramfuk_tipfiltera;
    }
    if (family === 'terkk$ramfuk/GRANICNIK_288' || family === 'terkk$ramfuk/GRANICNIK_493' || family === 'terkk$ramfuk/GRANICNIK_593') { // 1-
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$ramfuk/GRANICNIK";
      // virtel.tergrupa = 'NOVO';
      virtel.tip = p.tip;
      virtel.sirina = p.razvijenamera1;
      // virtel.ramfuk_tipfiltera = p.ramfuk_tipfiltera;
    }
    if (family === 'terkk$ramfuk/OJACANJE_V_UPROFIL_1' || family === 'terkk$ramfuk/OJACANJE_V_UPROFIL_2') { // 1-
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$ramfuk/OJACANJE_V_UPROFIL";
      // virtel.tergrupa = 'NOVO';
      virtel.tip = p.tip;
      virtel.visina = p.razvijenamera1;
    }
    if (family === 'terkk$ramfuk/DISTANCER_DUPLOG_KLIZACA') { // 1-
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$ramfuk/DISTANCER_DUPLOG_KLIZACA";
      // virtel.tergrupa = 'NOVO';
      virtel.tip = p.tip;
      virtel.visina = p.razvijenamera1;
    }

  }
  //
  // * rmt
  if (true) {
    if (family === 'terkk$rmt/SKLOP_RMT') { // 1.
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$rmt/SKLOP_RMT";
      // virtel.tergrupa = 'NOVO';
      // Za ASSEMBLY_TER_SKLOP se mora eksplicitno navesti svako polje koje treba da ide u virtel
      virtel.tip = p.tip;
      virtel.sirina = p.rmt_sirinarama;
      virtel.visina = p.rmt_visinarama;
    }
    if (family === 'terkk$rmtklizac/SKLOP_RMT_KLIZAC') { // 1.
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$rmt/SKLOP_RMT_KLIZAC";
      // virtel.tergrupa = 'NOVO';
      // Za ASSEMBLY_TER_SKLOP se mora eksplicitno navesti svako polje koje treba da ide u virtel
      virtel.tip = p.tip;
      virtel.sirina = p.sirina;
      virtel.tervrstaprofila_50_ili_70 = p.tervrstaprofila_50_ili_70;
    }
    if (family === 'terkk$rmt/NOSAC_TERMOSTATA') { // 5.
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$rmt/NOSAC_TERMOSTATA";
      virtel.sirina = p.razvijenamera1;
    }
    if (family === 'terkk$rmtklizac/LIM_OMEGA' || family === 'terkk$rmtklizac/LIM_OMEGA_1_2' || family === 'terkk$rmtklizac/LIM_OMEGA_2_2') { // 5.
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$rmt/LIM_OMEGA";
      virtel.tip = p.tip;
      virtel.sirina = p.razvijenamera1;
    }
    if (family === 'terkk$rmtklizac/LIM_U' || family === 'terkk$rmtklizac/LIM_U_1_2' || family === 'terkk$rmtklizac/LIM_U_2_2') { // 5.
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$rmt/LIM_U";
      virtel.tip = p.tip;
      virtel.sirina = p.razvijenamera1;
    }

  }
  //
  // * npr
  if (true) {
    if (family === 'terkk$npr/SKLOP_NPR') { // 1.
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$npr/SKLOP_NPR";
      virtel.distinction_key = p.distinction_key;
      // virtel.tergrupa = 'NOVO';
      // Za ASSEMBLY_TER_SKLOP se mora eksplicitno navesti svako polje koje treba da ide u virtel
      virtel.tip = p.tip;
      virtel.tervrstaprofila_50_ili_70 = p.tervrstaprofila_50_ili_70;
      virtel.duzinamodula = p.duzinamodula;
      virtel.npr_tipkomore = p.npr_tipkomore;
      virtel.npr_brojmodula = p.npr_brojmodula;
      virtel.npr_stranicarekuperatora = p.npr_stranicarekuperatora;
      virtel.npr_demperbypass = p.npr_demperbypass;

      //
      // TODO
      virtel.npr_sirinakomore = p.npr_sirinakomore;
      virtel.npr_visinakomore = p.npr_visinakomore;
      virtel.npr_visinadonjesekcije = p.npr_visinadonjesekcije;
      virtel.npr_visinagornjesekcije = p.npr_visinagornjesekcije;
      virtel.npr_sirinaprednjesekcije = p.npr_sirinaprednjesekcije;
      virtel.npr_sirinazadnjesekcije = p.npr_sirinazadnjesekcije;
    }
    if (family === 'terkk$nprpostolje/SKLOP_NPR_POSTOLJE') { //
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$npr/SKLOP_NPR_POSTOLJE";
      // virtel.tergrupa = 'NOVO';
      // Za ASSEMBLY_TER_SKLOP se mora eksplicitno navesti svako polje koje treba da ide u virtel
      virtel.tip = p.tip;
      virtel.npr_stranicarekuperatora = p.npr_stranicarekuperatora;
    }
    //
    if (family === 'terkk$npr/A_P1_B_P1' || family === 'terkk$npr/A_P2_B_P11' || family === 'terkk$npr/A_P3_B_P2' || family === 'terkk$npr/A_P4_B_P21' || family === 'terkk$npr/A_P5_B_P3' || family === 'terkk$npr/B_P5' || family === 'terkk$npr/B_P6' || family === 'terkk$npr/A_P5' || family === 'terkk$npr/B_P31' || family === 'terkk$npr/B_P32') { //
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$npr/AB";
      // virtel.sirina = p.razvijenamera1;
      virtel.dimenzija1 = p.dimenzija1;
      virtel.dimenzija2 = p.dimenzija2;
    }

  }
  //
  // * nrr
  if (true) {
    if (family === 'terkk$nrr/SKLOP_NRR') { // 1.
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$nrr/SKLOP_NRR";
      virtel.distinction_key = p.distinction_key;
      // virtel.tergrupa = 'NOVO';
      // Za ASSEMBLY_TER_SKLOP se mora eksplicitno navesti svako polje koje treba da ide u virtel
      virtel.sirina = p.nrr_sirinakomore;
      virtel.nrr_visinadonjesekcije = p.nrr_visinadonjesekcije;
      virtel.nrr_visinagornjesekcije = p.nrr_visinagornjesekcije;
      virtel.duzinamodula = p.duzinamodula;
      virtel.nrr_visinarekuperatora = p.nrr_visinarekuperatora;
      virtel.nrr_debljinarekuperatora = p.nrr_debljinarekuperatora;
      virtel.tervrstaprofila_50_ili_70 = p.tervrstaprofila_50_ili_70;
    }
    if (family === 'terkk$nrr/P1' || family === 'terkk$nrr/P2' || family === 'terkk$nrr/P3' || family === 'terkk$nrr/P4' || family === 'terkk$nrr/P5') { //
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$nrr/P";
      virtel.sirina = p.dimenzija1;
      virtel.visina = p.dimenzija2;
    }

  }
  //
  // * nosacv
  if (true) {
    if (family === 'terkk$ppvnosacv/SKLOP_B') { // 1.
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$ppvnosacv/SKLOP_B";
      virtel.distinction_key = p.distinction_key;
      // virtel.tergrupa = 'NOVO';
      // Za ASSEMBLY_TER_SKLOP se mora eksplicitno navesti svako polje koje treba da ide u virtel
      virtel.ppvnosacv_brojventilatoraponosacu = p.ppvnosacv_brojventilatoraponosacu;
      virtel.ppvnosacv_duzinanosacal = p.ppvnosacv_duzinanosacal;
      virtel.ppvnosacv_l1 = p.ppvnosacv_l1;
      virtel.ppvnosacv_l2 = p.ppvnosacv_l2;
      virtel.ppvnosacv_l3 = p.ppvnosacv_l3;
      virtel.ppvnosacv_precnikotvora = p.ppvnosacv_precnikotvora;
      virtel.ppvnosacv_unpmaska = p.ppvnosacv_unpmaska;
    }
    if (family === 'terkk$ppvnosacv/LIM_OMEGA_A') { //
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$ppvnosacv/LIM_OMEGA_A";
    }
    if (family === 'terkk$ppvnosacv/PROFIL_UNP_B') { //
      // TODO
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$ppvnosacv/PROFIL_UNP_B";
    }
    if (family === 'terkk$ppvnosacv/UNP_MASKA') { //
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$ppvnosacv/UNP_MASKA";
    }

  }
  //
  // * usmerivacvazduha ???
  if (true) {
    if (family === 'terkk$usmv/SKLOP_USMV') { // 1.
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$usmv/SKLOP_USMV";
      // virtel.tergrupa = 'NOVO';
      // Za ASSEMBLY_TER_SKLOP se mora eksplicitno navesti svako polje koje treba da ide u virtel

    }
    if (family === 'terkk$usmv/P1' || family === 'terkk$usmv/P2' || family === 'terkk$usmv/P3' || family === 'terkk$usmv/P4' || family === 'terkk$usmv/P5') { //
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$usmv/P";

    }

  }
  //
  // * paletapakovanja PAL
  if (true) {
    if (family === 'terkk$pal/SKLOP_PALETA') { // 1.
      virtel.virtelschemakey = "terkk$temp"; // TODO
      virtel.virtel_program_sas_by_lang = true; // TODO
      virtel.multitranslator_lang = "terkk$pal/SKLOP_PALETA";
      // virtel.tergrupa = 'NOVO';
      // Za ASSEMBLY_TER_SKLOP se mora eksplicitno navesti svako polje koje treba da ide u virtel
      virtel.sirina = p.pal_sirina; // DIRTY
      virtel.duzina = p.pal_duzina; // DIRTY
      virtel.visina = p.pal_visina; // DIRTY
      virtel.pal_kolikoklocniduzinski = p.pal_kolikoklocniduzinski; // DIRTY
      virtel.pal_kolikoklocnisirinski = p.pal_kolikoklocnisirinski; // DIRTY
      virtel.pal_kolikodasakaduzinski = p.pal_kolikodasakaduzinski; // DIRTY
      virtel.pal_kolikodasakasirinski = p.pal_kolikodasakasirinski; // DIRTY
      virtel.pal_toplotnotretiranje = p.pal_toplotnotretiranje; // DIRTY
    }

  }
  //
  // * novi
  if (true) {
    if (family === 'terkk$novi/SKLOP_NOVI') { // 1.

    }
    if (family === 'terkk$novi/SKLOP_NOVI2') { // 5.

    }

  }
  //
  //
  // NOVO 2025-03-18
  if (js_utils.is_string_not_empty(protobomp_superdata._extra_siframodula)) {
    // j._ident_modula = p._extra_siframodula; // NOVO 2025-03-18
    virtel._extra_siframodula = protobomp_superdata._extra_siframodula; // NOVO 2025-03-18
  } else {
    // else no changes
  }
  //
  //
  _dirty_enrich_virtel_with_dynamic_virtelclass(virtel, pbnode, op_no); // DIRTY
  return virtel; // DIRTY
};


//
const _pbnode_to_virbom_ASSEMBLY_TER_SKLOP = (pbnode, protobomp) => {
  const p = pbnode.state;
  let virtel_op1 = {
    //
    "terkategorija": "PP",
    "tergrupa": "SKLOP",
    jm: tclocal.JM_KOM,
    // termaterijal: '_p.identmaterijala',
    operacija: p.operacija1, // operacija 1
    rc: p.rc1, // rc 1
    //
    virtelschemakey: 'terkk$limcustom', // TODO
    // ...state, // TODO moramo rucno kasniej prepistai ostale promenjive iz pbnode statea
    naziv: p.naziv,
    kolicina: p.kolicina,
    //
  };
  //
  _dirty_enrich_virtel_from_pbnode(virtel_op1, pbnode, protobomp, 1);
  //
  let local_graphlevel = 1;
  let virbom_ref = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);
  // _virbom_manipulator.add_on_top_graphlevel(virbom_ref, _virtel, local_graphlevel);
  _virbom_manipulator.add_on_top_graphlevel(virbom_ref, _enrich_virtel_from_unbundled_subDraftel_arr_with_fresh_subkey(virtel_op1));
  //
  const virbom_seq = _virbom_manipulator.deinit(virbom_ref);
  return virbom_seq; // return virbom
};


//
const _pbnode_to_virbom_PRIMITIVE_TER_LIM = (pbnode, protobomp) => {
  const p = pbnode.state;
  const _p = p;
  // _p.duzina = _p.dimenzija1; // TODO BUG to treba posebno definisati za svaki pbnode_family
  // _p.sirina = _p.dimenzija2; // TODO BUG to treba posebno definisati za svaki pbnode_family
  let virbom_ref = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);
  let local_graphlevel = 1;
  let x; // JOCKER
  let xm; // JOCKER
  if (p.operacija2 && typeof p.operacija2 === 'string' && p.operacija2 !== '' && p.operacija2 !== 'OPNISTA') {
    // dve operacije
    // druga od dve
    const p2 = {
      ..._p,
      "terkategorija": "PP",
      "tergrupa": "LIM",
      jm: tclocal.JM_KOM,
      termaterijal: _p.identmaterijala, // ident materijala ide u secenje
      operacija: _p.operacija2, // operacija 2
      rc: _p.rc2, // rc 2
      //
      virtelschemakey: 'terkk$limcustom',
      // ...state,
      // flag_paired_with_smartel: false, // ovaj virtel direktno uparen sa smartel.subkey
      // ..._get_fixed_fields(sema),
      virtelclass: "terkk$limcustom",
      // ..._getParamsFromLib("terkk$limcustom") // parametri na kraju imaju prioritet
      cnccrtez: _p.cnccrtez,
    };
    let virtel_op2 = _enrich_virtel_from_unbundled_subDraftel_arr_with_fresh_subkey({
      // ...draftel_codecs_pack_terkk$_bundle_limcustom.subDrafel_to_virtel(p2),
      ...p2,
    });
    //
    _dirty_enrich_virtel_from_pbnode(virtel_op2, pbnode, protobomp, 2);
    //
    _virbom_manipulator.add_on_graphlevel(virbom_ref, virtel_op2, local_graphlevel);
    // prva od dve
    const p1 = {
      ..._p,
      "terkategorija": "PP",
      "tergrupa": "LIM",
      kolicina: SINGLE_PIECE_PER_NEXT_OPERATION_UNIT, // PO JEDNOM KOMADU SLEDECE OPERACIJE
      jm: tclocal.JM_KOM,
      termaterijal: _p.identmaterijala, // ident materijala ne ide kad nije secenje ali privremeno neka ostane
      operacija: _p.operacija1, // operacija 1
      rc: _p.rc1, // rc 1
      // derivat nema operaciju 1 i 2 nego samo prostu operaciju
      operacija1: null, // operacija 1
      rc1: null, // rc 1
      operacija2: null, // operacija 2
      rc2: null, // rc 2
      virtelschemakey: 'terkk$limcustom$derivat1',
      //
      virtelschemakey: 'terkk$limcustom',
      // ...state,
      // flag_paired_with_smartel: false, // ovaj virtel direktno uparen sa smartel.subkey
      // ..._get_fixed_fields(sema),
      virtelclass: "terkk$limcustom",
      // ..._getParamsFromLib("terkk$limcustom") // parametri na kraju imaju prioritet
      cnccrtez: _p.cnccrtez,
    };
    x = p2;
    let virtel_op1 = _enrich_virtel_from_unbundled_subDraftel_arr_with_fresh_subkey({
      // ...draftel_codecs_pack_terkk$_bundle_limcustom.subDrafel_to_virtel(p1),
      ...p1,
      virtelschemakey: 'terkk$limcustom$derivat1', // da bi bio autocreated on mora da koristi semu derivata koja se razlikuje samo po tome sto je za nju ukljuceno autocreate
    });
    //
    _dirty_enrich_virtel_from_pbnode(virtel_op1, pbnode, protobomp, 1);
    //
    _virbom_manipulator.add_as_last_virtel_children(virbom_ref, virtel_op1);
  } else {
    // 1 operacija
    const p1 = {
      ..._p,
      "terkategorija": "PP",
      "tergrupa": "LIM",
      jm: tclocal.JM_KOM,
      termaterijal: _p.identmaterijala,
      operacija: _p.operacija1, // operacija 1
      rc: _p.rc1, // rc 1
      //
      virtelschemakey: 'terkk$limcustom',
      // ...state,
      // flag_paired_with_smartel: false, // ovaj virtel direktno uparen sa smartel.subkey
      // ..._get_fixed_fields(sema),
      virtelclass: "terkk$limcustom",
      // ..._getParamsFromLib("terkk$limcustom") // parametri na kraju imaju prioritet
      cnccrtez: _p.cnccrtez,
    };
    x = p1;
    let virtel_op1 = _enrich_virtel_from_unbundled_subDraftel_arr_with_fresh_subkey({
      // ...draftel_codecs_pack_terkk$_bundle_limcustom.subDrafel_to_virtel(p1),
      ...p1,
    });
    //
    _dirty_enrich_virtel_from_pbnode(virtel_op1, pbnode, protobomp, 1);
    //
    _virbom_manipulator.add_on_graphlevel(virbom_ref, virtel_op1, local_graphlevel);
  }
  // zatim dodavanje njegovog materijala
  let naziv_materijala = "?";
  if (typeof x.naziv_materijala === 'string') {
    naziv_materijala = x.naziv_materijala;
  }
  xm = {
    // ...x,
    // virtelschemakey: "terkk$kadica$materijal1",
    virtelschemakey: "terkk$limcustom$materijal1",
    // "virtelclass": "terkk$kadica$materijal_lim",
    // "virtelclass": "terkk$kadica$materijal_lim",
    "terkategorija": "M",
    // "tergrupa": "LIM", // ne treba grupa za materijal
    // "ident": x.ident,
    // calculated_ident: x.ident,
    identmaterijala: x.identmaterijala,
    ident: x.identmaterijala,
    calculated_ident: x.identmaterijala,
    // "ident": x.ident,
    // identcustom: x.identmaterijala,
    // "naziv": "?",
    "naziv": naziv_materijala,
    // "tip": "", // TODO ???
    // "jm": "m2",
    "jm": tclocal.JM_M2,
    kolicina: x.povrsina,
    // virtelclass: "terkk$_grupa_lim.1_materijal",
  }
  _virbom_manipulator.add_as_last_virtel_children(virbom_ref, _enrich_virtel_from_unbundled_subDraftel_arr_with_fresh_subkey(xm)); // NAPOMENA: moramo da mu dodamo subkey jer ga ovde kreiramo automatski a nigde nismo izvršili merge i on do sada nije imao subkey.
  //
  const virbom_seq = _virbom_manipulator.deinit(virbom_ref);
  return virbom_seq; // return virbom
};


//
const _pbnode_to_virbom_PRIMITIVE_TER_PROFIL = (pbnode, protobomp) => {
  const p = pbnode.state;
  const _p = p;
  let virbom_ref = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);
  let local_graphlevel = 1;
  let x; // JOCKER
  let xm; // JOCKER
  //
  x = {
    virtelschemakey: 'terkk$profilcustom',
    // ...state,
    ..._p,
    // flag_paired_with_smartel: false, // ovaj virtel direktno uparen sa smartel.subkey
    // ..._get_fixed_fields(sema),
    virtelclass: "terkk$profilcustom", // TODO
    "terkategorija": "PP",
    "tergrupa": "PROFIL", // TODO
    "jm": tclocal.JM_KOM,
    // termaterijal: state.identmaterijala,
    termaterijal: _p.identmaterijala,
    // ..._getParamsFromLib("terkk$profilcustom") // parametri na kraju imaju prioritet
    operacija: _p.operacija1, // operacija 1
    rc: _p.rc1, // rc 1
  };
  let virtel_op1 = _enrich_virtel_from_unbundled_subDraftel_arr_with_fresh_subkey({
    // ...draftel_codecs_pack_terkk$_bundle_limcustom.subDrafel_to_virtel(p2),
    ...x,
  });
  //
  _dirty_enrich_virtel_from_pbnode(virtel_op1, pbnode, protobomp, 1);
  //
  _virbom_manipulator.add_on_graphlevel(virbom_ref, virtel_op1, local_graphlevel);
  // zatim dodavanje njegovog materijala
  const _kolicina = x.duzina * SINGLE_PIECE_PER_NEXT_OPERATION_UNIT; // PO JEDNOM KOMADU SLEDECE OPERACIJE
  let naziv_materijala = "?";
  if (typeof x.naziv_materijala === 'string') {
    naziv_materijala = x.naziv_materijala;
  }
  xm = {
    virtelschemakey: 'terkk$profilcustom$materijal1',
    "terkategorija": "M",
    // "tergrupa": "LIM", // ne treba grupa za materijal
    // naziv: '?',
    "naziv": naziv_materijala,
    // x.calculated_ident = p.tip;
    // identmaterijala: x.identmaterijala,
    ident: x.identmaterijala,
    calculated_ident: x.identmaterijala,
    kolicina: terUtilsUnitsMilimetriToMetri(_kolicina, 3), // KONVERTUJEMO U METRE
    jm: tclocal.JM_M,
  };
  _virbom_manipulator.add_as_last_virtel_children(virbom_ref, _enrich_virtel_from_unbundled_subDraftel_arr_with_fresh_subkey(xm)); // NAPOMENA: moramo da mu dodamo subkey jer ga ovde kreiramo automatski a nigde nismo izvršili merge i on do sada nije imao subkey.
  //
  const virbom_seq = _virbom_manipulator.deinit(virbom_ref);
  return virbom_seq; // return virbom
};


//
const _pbnode_to_virbom_PRIMITIVE_TER_KAMENAVUNA = (pbnode, protobomp) => {
  const p = pbnode.state;
  const _p = p;
  let virbom_ref = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);
  let local_graphlevel = 1;
  let x; // JOCKER
  let xm; // JOCKER
  //
  x = {
    virtelschemakey: 'terkk$panel$derivat1', // TODO
    // ...state,
    ..._p,
    // flag_paired_with_smartel: false, // ovaj virtel direktno uparen sa smartel.subkey
    // ..._get_fixed_fields(sema),
    virtelclass: "terkk$panel$ispuna",
    "terkategorija": "PP",
    "tergrupa": "ISPUNA",
    // "jm": tclocal.JM_KOM,
    // termaterijal: state.identmaterijala,
    termaterijal: _p.identmaterijala,
    multitranslator_lang: "terkk$grupa_ispuna/grupa_ispuna",
    ..._getParamsFromLib("terkk$panel$ispuna") // parametri na kraju imaju prioritet
  };
  let virtel_op1 = _enrich_virtel_from_unbundled_subDraftel_arr_with_fresh_subkey({
    // ...draftel_codecs_pack_terkk$_bundle_limcustom.subDrafel_to_virtel(p2),
    ...x,
  });
  //
  _dirty_enrich_virtel_from_pbnode(virtel_op1, pbnode, protobomp, 1);
  //
  _virbom_manipulator.add_on_graphlevel(virbom_ref, virtel_op1, local_graphlevel);
  // zatim dodavanje njegovog materijala
  // const _kolicina = x.duzina * SINGLE_PIECE_PER_NEXT_OPERATION_UNIT; // PO JEDNOM KOMADU SLEDECE OPERACIJE
  let naziv_materijala = "?";
  if (typeof x.naziv_materijala === 'string') {
    naziv_materijala = x.naziv_materijala;
  }
  xm = {
    virtelschemakey: 'terkk$profilcustom$materijal1',
    "terkategorija": "M",
    // "tergrupa": "LIM", // ne treba grupa za materijal
    // naziv: '?',
    "naziv": naziv_materijala,
    // x.calculated_ident = p.tip;
    // identmaterijala: x.identmaterijala,
    ident: x.identmaterijala,
    calculated_ident: x.identmaterijala,
    kolicina: x.povrsina, // povrsian je vec konvertovana u jedinice
    jm: tclocal.JM_M2,
  };
  _virbom_manipulator.add_as_last_virtel_children(virbom_ref, _enrich_virtel_from_unbundled_subDraftel_arr_with_fresh_subkey(xm)); // NAPOMENA: moramo da mu dodamo subkey jer ga ovde kreiramo automatski a nigde nismo izvršili merge i on do sada nije imao subkey.
  //
  const virbom_seq = _virbom_manipulator.deinit(virbom_ref);
  return virbom_seq; // return virbom
};


//
const _pbnode_to_virbom_PRIMITIVE_TER_MATERIJAL = (pbnode) => {
  const p = pbnode.state;
  const _p = p;
  let virbom_ref = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);
  let local_graphlevel = 1;
  let x; // JOCKER
  let xm; // JOCKER
  //
  // zatim dodavanje njegovog materijala
  // const _kolicina = x.duzina * SINGLE_PIECE_PER_NEXT_OPERATION_UNIT; // PO JEDNOM KOMADU SLEDECE OPERACIJE
  xm = {
    //
    // terkknivo: 'CHILDOFMODUL', // ???
    // ID polje ne ide u preset, dobija se samo u EDIT MODE ali i tada mora biti obezbedjeno
    terkategorija: p.terkategorija,
    tergrupacustom: p.tergrupacustom,
    identcustom: p.identcustom,
    naziv: p.naziv,
    // naziv: p.naziv_materijala,
    kolicina: p.kolicina,
    jm: p.jm,
    Par28: p.Par28,
    Par29: p.Par29,
    //
    virtelschemakey: 'terkk$materijalcustom',
    virtelclass: 'terkk$materijalcustom',
    //...state,
    // flag_paired_with_smartel: true, // ovaj virtel direktno uparen sa smartel.subkey
    // ..._get_fixed_fields(sema),
    ..._getParamsFromLib("terkk$materijalcustom") // parametri na kraju imaju prioritet
  };
  _virbom_manipulator.add_on_graphlevel(virbom_ref, _enrich_virtel_from_unbundled_subDraftel_arr_with_fresh_subkey(xm), local_graphlevel); // NAPOMENA: moramo da mu dodamo subkey jer ga ovde kreiramo automatski a nigde nismo izvršili merge i on do sada nije imao subkey.
  //
  const virbom_seq = _virbom_manipulator.deinit(virbom_ref);
  return virbom_seq; // return virbom
};



draftel_codecs_pack_terkk$_special_protobomp.protobomp_multi_to_virbom = (_protobomp_multi) => {
  //
  let virbom_ref = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);


  _protobomp_multi.forEach((protobomp) => {
    //
    const _dirty_traverse = (protobomp) => {
      //
      const _tree_single = (pbnode, this_graphlevel) => {
        const {
          tempkey
        } = pbnode;
        //
        if (pbnode && pbnode.state && 'kolicina' in pbnode.state && pbnode.state.kolicina > 0) {
          // u sastavnicu idu samo pbnode-i ukoliko je kolicina > 0
          // convert pbnode to local_virbom
          let local_graphlevel = this_graphlevel;
          // const _generate_fresh_subkey = virbomCounter.generateFreshSubkey;
          const _generate_fresh_subkey = null; // NAPOMENA: svakom virtelu u _slave_virbom smo vec dodelili subkey pomocu funkcije enrich_virtel...
          if (pbnode.pbnode_class === tclocal.ASSEMBLY_TER_SKLOP) {
            const _slave_virbom = _pbnode_to_virbom_ASSEMBLY_TER_SKLOP(pbnode, protobomp);
            _virbom_manipulator._merge_virbom_into_virbom_on_graphlevel(virbom_ref, _slave_virbom, local_graphlevel, _generate_fresh_subkey);
          } else if (pbnode.pbnode_class === tclocal.PRIMITIVE_TER_LIM) {
            const _slave_virbom = _pbnode_to_virbom_PRIMITIVE_TER_LIM(pbnode, protobomp);
            _virbom_manipulator._merge_virbom_into_virbom_on_graphlevel(virbom_ref, _slave_virbom, local_graphlevel, _generate_fresh_subkey);
          } else if (pbnode.pbnode_class === tclocal.PRIMITIVE_TER_PROFIL) {
            const _slave_virbom = _pbnode_to_virbom_PRIMITIVE_TER_PROFIL(pbnode, protobomp);
            _virbom_manipulator._merge_virbom_into_virbom_on_graphlevel(virbom_ref, _slave_virbom, local_graphlevel, _generate_fresh_subkey);
          } else if (pbnode.pbnode_class === tclocal.PRIMITIVE_TER_KAMENAVUNA) {
            const _slave_virbom = _pbnode_to_virbom_PRIMITIVE_TER_KAMENAVUNA(pbnode, protobomp);
            _virbom_manipulator._merge_virbom_into_virbom_on_graphlevel(virbom_ref, _slave_virbom, local_graphlevel, _generate_fresh_subkey);
          } else if (pbnode.pbnode_class === tclocal.PRIMITIVE_TER_MATERIJAL) {
            const _slave_virbom = _pbnode_to_virbom_PRIMITIVE_TER_MATERIJAL(pbnode, protobomp);
            _virbom_manipulator._merge_virbom_into_virbom_on_graphlevel(virbom_ref, _slave_virbom, local_graphlevel, _generate_fresh_subkey);
            // experimental
            /*
          } else if (pbnode.pbnode_class === 'ASSEMBLY_ZZKITC_ASY') {
            const _slave_virbom = _pbnode_to_virbom_ASSEMBLY_ZZKITC_ASY(pbnode, protobomp);
            _virbom_manipulator._merge_virbom_into_virbom_on_graphlevel(virbom_ref, _slave_virbom, local_graphlevel, _generate_fresh_subkey);
            */
            /*
            } else if (pbnode.pbnode_class === 'PRIMITIVE_ZZKITC_WBP') {
              const _slave_virbom = _pbnode_to_virbom_PRIMITIVE_ZZKITC_WBP(pbnode, protobomp);
              _virbom_manipulator._merge_virbom_into_virbom_on_graphlevel(virbom_ref, _slave_virbom, local_graphlevel, _generate_fresh_subkey);
              */
          }
          //
          // children...
          if (pbnode.type_is_assembly === true) {
            const target_graphlevel = this_graphlevel + 1;
            const children_pbnode_arr = protobomp_utils_get_children_of_pbnode(protobomp, tempkey);
            _tree_each(children_pbnode_arr, target_graphlevel);
          }
        }
        //
      }; // end of _dirty_tree_single
      //
      const _tree_each = (arr, target_graphlevel) => {
        // each child of pbnode with 
        arr.forEach((pbnode) => {
          _tree_single(pbnode, target_graphlevel);
        });
      }; //
      // START TRAVERSING
      const target_graphlevel = 1;
      const children_pbnode_arr = protobomp_utils_get_children_of_pbnode(protobomp, null); // start from root level (null)
      _tree_each(children_pbnode_arr, target_graphlevel); // start from root level (null)
    };

    _dirty_traverse(protobomp);

    // ZAVRSENI KORACI ZA JEDAN protobomp
  });

  const virbom_seq = _virbom_manipulator.deinit(virbom_ref);
  return virbom_seq; // return virbom
};




// ---------- CODEC DECODING - VIRBOM TO DRAFTEL DIRECTION ----------
// ZA NOVE POLUPROIZVODE NECEMO NI KORISTITI DECODING

